// This file was automatically generated from ptdata.vitalsCollections.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.vitalsCollections');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol><li class="el8InlineItem el8AppLightText">', (soy.$$escapeHtml(opt_data.collectedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.collectedDate)) : ''), '</li>');
  el8.template.ptdata.vitalsCollections.vitalSummary(soy.$$augmentData(opt_data, {isPrintForm: false}), output);
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.printSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="vitals"><tr><td class="el8InlineItem el8SystemText">', (soy.$$escapeHtml(opt_data.collectedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.collectedDate)) : ''), ':');
  el8.template.ptdata.vitalsCollections.vitalSummary(soy.$$augmentData(opt_data, {isPrintForm: true}), output);
  output.append('</td></tr></table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.singleVital = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isPrintForm) {
    output.append('<span class="vitalsIndent">');
    el8.template.ptdata.vitalsCollections.singleVitalText_(opt_data, output);
    output.append('</span>');
  } else {
    output.append('<li class="el8InlineItem">');
    el8.template.ptdata.vitalsCollections.singleVitalText_(opt_data, output);
    output.append('</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.bpVitals = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isPrintForm) {
    output.append('<span class="vitalsIndent">BP: ');
    var bList22530 = opt_data.bps;
    var bListLen22530 = bList22530.length;
    for (var bIndex22530 = 0; bIndex22530 < bListLen22530; bIndex22530++) {
      var bData22530 = bList22530[bIndex22530];
      el8.template.ptdata.vitalsCollections.bpText(bData22530, output);
      output.append((! (bIndex22530 == bListLen22530 - 1)) ? ', ' : '');
    }
    output.append('</span>');
  } else {
    output.append('<li class="el8InlineItem el8RightIndent">BP: ');
    var bList22539 = opt_data.bps;
    var bListLen22539 = bList22539.length;
    for (var bIndex22539 = 0; bIndex22539 < bListLen22539; bIndex22539++) {
      var bData22539 = bList22539[bIndex22539];
      el8.template.ptdata.vitalsCollections.bpText(bData22539, output);
      output.append((! (bIndex22539 == bListLen22539 - 1)) ? ', ' : '');
    }
    output.append('</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.singleVitalText_ = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(opt_data.name, ': ', (opt_data.val) ? soy.$$escapeHtml(opt_data.val) + ((opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '') : '', (opt_data.note) ? '<span class="el8Preserve el8LeftIndent">(' + soy.$$escapeHtml(opt_data.note) + ')</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.bpText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.bpS) ? soy.$$escapeHtml(opt_data.bpS) : '', '<span>/</span>', (opt_data.bpD) ? soy.$$escapeHtml(opt_data.bpD) : '', (opt_data.bpNote) ? '<span class="el8Preserve el8LeftIndent">(' + soy.$$escapeHtml(opt_data.bpNote) + ')</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.vitalSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.bps.length) {
    el8.template.ptdata.vitalsCollections.bpVitals({bps: opt_data.bps, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.hr || opt_data.hrNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'HR', val: opt_data.hr, note: opt_data.hrNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.temperature || opt_data.tempNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'Temp', val: opt_data.temperature, note: opt_data.tempNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.rr || opt_data.rrNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'RR', val: opt_data.rr, note: opt_data.rrNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.height || opt_data.htNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'Ht', val: opt_data.height, units: 'in.', note: opt_data.htNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.weight || opt_data.wtNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'Wt', val: opt_data.weight, units: 'lbs.', note: opt_data.wtNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.bmi) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'BMI', val: opt_data.bmi, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.oxygen || opt_data.oxygenNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'O<span class="subscript">2</span>', val: opt_data.oxygen, note: opt_data.oxygenNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.hc || opt_data.hcNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'HC', val: opt_data.hc, units: 'cm.', note: opt_data.hcNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (opt_data.pain || opt_data.painNote) {
    el8.template.ptdata.vitalsCollections.singleVital({name: 'Pain', val: opt_data.pain, note: opt_data.painNote, isPrintForm: opt_data.isPrintForm}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.vitalsCollections.previousVital = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.previousValue) ? (opt_data.delta) ? '[' + soy.$$escapeHtml(opt_data.delta) + ' from ' + soy.$$escapeHtml(opt_data.previousValue) + ((opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '') + ' on ' + (soy.$$escapeHtml(opt_data.previousTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.previousTime)) : '') + ']' : '[' + soy.$$escapeHtml(opt_data.previousValue) + ((opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '') + ' on ' + (soy.$$escapeHtml(opt_data.previousTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.previousTime)) : '') + ']' : '');
  if (!opt_sb) return output.toString();
};
